import type { RecordCreator } from "@/types/api";

/** Full name, falling back to the email when no name is set. */
export function creatorDisplayName(creator: RecordCreator): string {
  const name = `${creator.first_name} ${creator.last_name}`.trim();
  return name || creator.email;
}

/** Up to two initials for the avatar fallback. */
export function creatorInitials(creator: RecordCreator): string {
  const first = creator.first_name.trim();
  const last = creator.last_name.trim();
  const initials = `${first.charAt(0)}${last.charAt(0)}`.trim();
  return (initials || creator.email.charAt(0)).toUpperCase();
}
